import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './LoadingStyles';

export default class Loading extends Component {
  render() {
    return (
      <div className={css(styles.loaderWrapper)}>
        <div
          className={css(
            [styles.loader],
            this.props.onDark && styles.loaderOnDark
          )}
        >
          Loading&hellip;
        </div>
        <strong
          className={css([
            styles.title,
            this.props.onDark && styles.titleOnDark
          ])}
        >
          {this.props.title ? `${this.props.title}…` : 'Loading…'}
        </strong>
      </div>
    );
  }
}
